import { useApiUrl } from '@refinedev/core';
import { useQuery } from 'react-query';

import { ProjectTemplateTest } from '../types';
import httpClient from '../utils/axios';

/**
 * Given a testId will fetch scenarios information.
 */
const useDetailedProjectTemplateTest = (testId: string) => {
  const apiUrl = useApiUrl();
  const query = useQuery(
    ['testScenarios', testId],
    async () => {
      const { data } = await httpClient.get<ProjectTemplateTest>(
        `${apiUrl}/assessment_template_tests/${testId}?detailed=True&ordering=order`
      );
      return data;
    },
    {
      refetchOnWindowFocus: false
    }
  );

  return query;
};

export default useDetailedProjectTemplateTest;
